import { cn } from "~/lib/utils";

// // // //

// ENHANCEMENT - this card pattern should be built into a dedicated component (this is copy/pasted in many places)
export function TokenHoldersCard(props: {
    title: string;
    token_count: number;
    children: React.ReactNode;
}) {
    const { title, token_count, children } = props;
    return (
        <div
            className={cn(
                "pt-5 bg-card rounded-lg shadow-xs border overflow-clip",
                "col-span-1 flex flex-col justify-between",
                `col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 2xl:col-span-12`,
            )}
        >
            <div
                className={cn(
                    "flex flex-col gap-2 md:flex-row md:justify-between md:items-center",
                    {
                        "mb-4": token_count < 2,
                        "mb-2 lg:mb-4": token_count >= 2,
                    },
                )}
            >
                <div className="w-full">
                    <p className="text-foreground text-xl leading px-5">
                        {title}
                    </p>
                </div>
            </div>

            <div className="flex flex-col border-t">{children}</div>
        </div>
    );
}
